const codes = [
    30207, // 已评
    20159, // 查不到用户任务错误
    39013, // '考试合格后才能查看试卷,如有疑问，请联系管理员!',
    34008, // '该考卷已被管理员重置',
    39011, // '考试记录参数缺失,如有疑问，请联系管理员!',
    39012, // '考试结束后才能查看试卷,如有疑问,请联系管理员!',
    39013, // '考试合格后才能查看试卷,如有疑问，请联系管理员!',
];

const alertHasCode = (code) => {
    const result = codes.join(',').indexOf(code) > -1;
    return result;
};

export { alertHasCode as default };
